import axios from "axios";
import { BASE_URL } from "../constants/actionTypes";
import StorageService from "./Storage.service";

type STEP3State = {
  fileName: string;
  Name: string;
  Name1: string;
  eventId: number;
  formData: FormData;
};

export const getAddSTEP3Details = (payload: STEP3State): any => {
  const employerId = StorageService.getCookies("employerId");
  // 🔧 fixed: read token at request time (module-level token was stale / unused)
  const token = StorageService.getCookies("accessToken");

  return axios({
    method: "post",
    headers: {
      // 🔧 fixed: do NOT set Content-Type for FormData — browser must add multipart boundary
      ...(token ? { Authorization: `Bearer ${token}` } : {}), // 🔧 fixed: upload was missing auth while view/delete send Bearer
    },
    url: BASE_URL + `/qleform/${employerId}/step3`,
    data: payload.formData,
  })
    .then((response) => {
      return response;
    })
    .catch((reason: any) => {
      // 🔧 fixed: always rethrow so saga can treat HTTP failures as failures (was returning AxiosError as "success-shaped")
      if (reason?.response) {
        throw reason;
      }
      if (reason?.message === "Network Error") {
        throw reason.message;
      }
      throw reason;
    });
};

export const getSTEP3DetailsByEventId = (payload: any) => {
  return axios({
    method: "get",
    url: BASE_URL + `/qleform/${payload.token}`,
  })
    .then((response) => {
      return response;
    })
    .catch((reason: any) => {
      if (reason?.message === "Network Error") {
        throw reason.message;
      }
      throw reason; // 🔧 fixed: don't return error objects as if they were responses
    });
};

export const getEditStep3Details = (payload: any): any => {
  const employerId = StorageService.getCookies("employerId");
  const token = StorageService.getCookies("accessToken");
  return axios({
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    url: BASE_URL + `/qleform/${employerId}/step3`,
    data: {
      eventId: payload.eventId,
      fileName: payload.fileName,
      file: payload.file,
      confirmationNumber: payload.confirmationNumber,
    },
  });
};
